<template>
  <Teleport to="body">
    <Transition name="loading-fade" appear>
      <div
        v-if="store.visible"
        class="loading-overlay"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div class="loading-container">
          <!-- Background Blur -->
          <div class="loading-backdrop"></div>
          
          <!-- Loading Content -->
          <div class="loading-content">
            <!-- Animated Spinner -->
            <div class="spinner-container">
              <div class="spinner-ring">
                <div class="spinner-ring-inner"></div>
              </div>
              <div class="spinner-dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
            
            <!-- Loading Text -->
            <div class="loading-text">
              <h3 class="loading-title">Loading</h3>
              <p class="loading-subtitle">Please wait while we process your request</p>
            </div>
            
            <!-- Progress Bar -->
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress-fill"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { useGlobalLoadingStore } from '@/components/helper/loading'
import '@/components/style/Loading.css'
const store = useGlobalLoadingStore()
</script>

